@if (!isPopupWindow) {
  <div cdkDropListGroup data-cy="app-main-container">
    @if (uiService.isShowSearch) {
      <app-tdo-global-search (clickedOutside)="uiService.isShowSearch = false;" style="position: absolute; z-index: 4000; width: 100vw; height: 100vh; top: 42px; pointer-events: auto;" data-cy="app-globalsearch-panel"></app-tdo-global-search>
    }
    @if (showHeader) {
      <app-tdo-header data-cy="app-header-nav"></app-tdo-header>
    }
    @if (showNotes) {
      <app-note-example data-cy="app-notes-panel"></app-note-example>
    }
    @if (showNotifications) {
      <app-notifications data-cy="app-notifications-panel"></app-notifications>
    }
    @if (showLiveChat) {
      <app-office-communication style="z-index: 9000;" data-cy="app-livechat-panel"></app-office-communication>
    }
    @if (isLoading) {
      <div class="spinnder-div" data-cy="app-loading-container">
        <div class="spinner-holder">
          <mat-spinner data-cy="app-loading-spinner"></mat-spinner>
        </div>
      </div>
    }
    <div style="width: 100%; height: 100%;" data-cy="app-content-container">
      <router-outlet></router-outlet>
    </div>
  </div>
}
@if (isPopupWindow) {
  <div class="popup-window" data-cy="app-popup-window">
    <router-outlet></router-outlet>
  </div>
}
